<template><section><h4>Vant 在企业微信的调试工具</h4>
<h5>1、进入企业微信入口</h5>
<p><code v-pre>https://work.weixin.qq.com/wework_admin/loginpage_wx?from=myhome</code></p>
<h5>2、找到 &quot;我的企业&quot; -- &quot;微工作台&quot; --&quot;开发者工具&quot;</h5>
<h6>setp1:</h6>
<img src="../assets/images/pic1.png" width="700px">
<h6>setp2:</h6>
<img src="../assets/images/pic2.png" width="700px">
<p>这是有赞官网<a href="https://youzan.github.io/vant/#/zh-CN/quickstart" title="Vant官网">Vant官网</a>.</p>
<template>
</template>


</section></template>
<style>
  .card{
    margin:auto;
    width: 600px;
    text-align: center;
  }
</style>
<script>
// @ is an alias to /src

import pic from '../assets/logo.png'
export default {
  name: 'Home',
  components: {
    
  },
  methods:{
      clickFn(){
          alert('aa')
      }
  }
}
</script>